import { z } from 'zod';
import { isoDateSchema, timestampedSchema, uuidSchema } from './common';

export const assessmentScaleSchema = z.enum(['emerging_ready_strong', 'one_to_five', 'yes_no']);
export type AssessmentScale = z.infer<typeof assessmentScaleSchema>;

export const assessmentCriterionSchema = z.object({
  key: z.string().trim().min(1).max(80),
  label: z.string().trim().min(1).max(120),
  scale: assessmentScaleSchema.default('emerging_ready_strong'),
});
export type AssessmentCriterion = z.infer<typeof assessmentCriterionSchema>;

export const assessmentScoreSchema = z.record(z.union([z.string(), z.number(), z.boolean()]));
export type AssessmentScore = z.infer<typeof assessmentScoreSchema>;

export const assessmentTemplateInputSchema = z.object({
  name: z.string().trim().min(1).max(160),
  program_id: uuidSchema.optional(),
  criteria: z.array(assessmentCriterionSchema).min(1).max(40),
  active: z.boolean().default(true),
});
export type AssessmentTemplateInput = z.input<typeof assessmentTemplateInputSchema>;

export const assessmentTemplateSchema = timestampedSchema.extend({
  name: z.string(),
  program_id: uuidSchema.nullable(),
  criteria: z.array(assessmentCriterionSchema),
  active: z.boolean(),
});
export type AssessmentTemplate = z.infer<typeof assessmentTemplateSchema>;

export const dancerAssessmentInputSchema = z.object({
  dancer_id: uuidSchema,
  template_id: uuidSchema,
  class_id: uuidSchema.optional(),
  instructor_id: uuidSchema.optional(),
  assessed_on: isoDateSchema.optional(),
  scores: assessmentScoreSchema,
  summary: z.string().trim().max(5000).optional(),
  parent_visible: z.boolean().default(false),
});
export type DancerAssessmentInput = z.input<typeof dancerAssessmentInputSchema>;

export const dancerAssessmentSchema = timestampedSchema.extend({
  dancer_id: uuidSchema,
  template_id: uuidSchema,
  class_id: uuidSchema.nullable(),
  instructor_id: uuidSchema.nullable(),
  assessed_on: isoDateSchema,
  scores: assessmentScoreSchema,
  summary: z.string().nullable(),
  parent_visible: z.boolean(),
});
export type DancerAssessment = z.infer<typeof dancerAssessmentSchema>;
